import React,{useEffect,useState,useContext} from 'react';
import ReactTooltip from 'react-tooltip';
import { Form, FormCheck, FormControl, InputGroup, Dropdown, DropdownButton, Container, Row, Col, Modal, Button } from 'react-bootstrap';
// , SplitButton
// import { Link } from "react-router-dom";

import { user_access_level, user_account_level, organization_user_access_level, org_friendly_url, org_uuid, user_entity_uuid, apiUrl, myHeaders_Auth_With_Cache_Control, owner_perms } from "Api/Api";
import axios from "axios";

import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

import { assembleNickname, get_modified_image_url, get_link_base_url } from "utils/Helper.js";

import './style.css';


function ShareAccessModal (props) {
  console.log('SHARE ACCESS MODAL PROPS:', props);

  //const [entities_array, setEntitiesArray] = useState({});
  //const [publish_dropdown_option_index, setPublishDropdownOptionIndex] = useState(props.publish_dropdown_option_index);
  const [entity_access_array, setEntityAccessArray] = useState([]);
  const [add_user_read_write_option_index, setAddUserReadWriteOptionIndex] = useState(0); // 'Can Edit' will show first
  const [add_user_text, setAddUserText] = useState('');
  const [add_user_text_invalid, setAddUserTextInvalid] = useState('');
  const [add_user_text_valid, setAddUserTextValid] = useState('');
  const [loading, setLoading] = useState(false);
  
  //const [publish_dropdown_options,setPublishDropdownOptions] = useState([]);
  const [publish_dropdown_option_index, setPublishDropdownOptionIndex] = useState(props.publish_dropdown_option_index);

  const [total_presenters,setTotalPresenters] = useState(0);
  //const [workspace_base_url,setWorkspaceBaseUrl] = useState('');

  const user_context = useContext(UserContext);

  //console.log("ShareAccessModal",owner_perms);

  
  let read_write_options = [
    {
      title: "Can Edit",
      action: 'write',
      icon: <i className="fa fa-edit"/>
    },
    {
      title: "Can View",
      action: 'read',
      icon: <i className="fa fa-eye"/>
    },
    {
      title: "Remove",
      action: 'remove',
      icon: <i className="fa fa-times-circle"/>
    },
    {
      title: "Presenter",
      action: 'presenter_only',
      icon: <i className="fa fauser"/>
    },
  ];
  
  
  
  async function handlePublishDropdownChange (tmp_publish_dropdown_option_index) {
    console.log("handlePublishDropdownChange", props.entity_info, tmp_publish_dropdown_option_index, props.publish_dropdown_options[tmp_publish_dropdown_option_index]);
  
    let patch_obj = {};
    patch_obj.public_status = props.publish_dropdown_options[tmp_publish_dropdown_option_index].public_status;

    setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
    setAddUserReadWriteOptionIndex(0);
    if (props.OnChangePublishOption && props.index) {
      props.OnChangePublishOption(patch_obj,props.entity_info,props.index);
    }

    await axios.patch(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`,patch_obj);
    
    setAddUserTextInvalid('');
    setAddUserTextValid('Privacy setting changed to \''+props.publish_dropdown_options[tmp_publish_dropdown_option_index].title+'\'');
    
    
    // bust cache if not draft
    if (props.entity_info.status_code === 1) {
      axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.friendly_url}`, myHeaders_Auth_With_Cache_Control);
    }

    //props.OnChangePublishOption(patch_obj,props.entity_info,props.index);
  }
  
  async function handleSharedAccessDropdownChange (entity_info,entity_access_array_index,tmp_shared_access_dropdown_option_index) {
    //console.log("handleSharedAccessDropdownChange",entity_info,tmp_shared_access_dropdown_option_index);

    let read_write_option_obj = read_write_options[tmp_shared_access_dropdown_option_index];
    console.log("handleSharedAccessDropdownChange",entity_info,tmp_shared_access_dropdown_option_index, read_write_option_obj);
    let patch_obj = {};
    
    let tmp_entity_access_array = [...entity_access_array];
    
    let tmp_message = "";
    
    if (read_write_option_obj.action === 'write') {
      patch_obj = {
        [entity_info.entity_type]: [
          {
            entity_uuid: entity_info.entity_uuid,
            xref_data: {
              entity_owner_integer: 2,
              entity_reader_integer: -1
            }
          }
        ]
      }
      if (props.entity_info.entity_type === 'presentations') {
        // also grant access to all the related slides
        let params = {
          filter_obj: {
            order_integer: {
              gte: 1
            }
          }
        }
        let slides_result = await axios.get(`${apiUrl}presentations/${props.entity_info.entity_uuid}/slides`, { params });
        if (slides_result.data) {
          let slide_update_promises = [];
          slides_result.data.forEach( element => {
            let slide_patch_obj = {
              [entity_info.entity_type]: [
                {
                  entity_uuid: entity_info.entity_uuid,
                  xref_data: {
                    entity_owner_integer: 2,
                    //entity_reader_integer: -1
                  }
                }
              ]
            }
            slide_update_promises.push(axios.patch(`${apiUrl}slides/${element.entity_uuid}`,slide_patch_obj));
          });
          await Promise.all(slide_update_promises);
        }
      }
      tmp_entity_access_array[entity_access_array_index].read_write_option_index = tmp_shared_access_dropdown_option_index;
      if (entity_info.presenter_integer >= 1) {
        // if switching legacy presenter to owner, disabled ability to remove
        tmp_entity_access_array[entity_access_array_index].disabled = true;
      }
      tmp_message = 'Write access granted to \''+entity_access_array[entity_access_array_index].nickname+'\'';
    } else if (read_write_option_obj.action === 'read') {
      patch_obj = {
        [entity_info.entity_type]: [
          {
            entity_uuid: entity_info.entity_uuid,
            xref_data: {
              entity_owner_integer: -1,
              entity_reader_integer: 2
            }
          }
        ]
      }
      tmp_entity_access_array[entity_access_array_index].read_write_option_index = tmp_shared_access_dropdown_option_index;
      tmp_message = 'Read access granted to \''+entity_access_array[entity_access_array_index].nickname+'\'';
    } else if (read_write_option_obj.action === 'remove') {
      patch_obj = {
        [entity_info.entity_type]: [
          {
            entity_uuid: entity_info.entity_uuid,
            xref_data: {
              entity_owner_integer: -1,
              //entity_reader_integer: -1
            }
          }
        ]
      }
      if (entity_info.entity_type === 'presentations' || entity_info.entity_type === 'events') {
        patch_obj[entity_info.entity_type][0].xref_data.entity_reader_integer = -1;
      }
      tmp_entity_access_array.splice(entity_access_array_index,1);
      tmp_message = 'Access removed for \''+entity_access_array[entity_access_array_index].nickname+'\'';
    }

    console.log("patch_obj",patch_obj);
    
    await axios.patch(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`,patch_obj);
    setEntityAccessArray(tmp_entity_access_array);
    setAddUserTextInvalid('');
    setAddUserTextValid(tmp_message);
    setLoading(false);
    
    //setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
    //props.OnChangePublishOption(patch_obj,props.entity_info,props.index);

    // bust cache if not draft
    //if (props.entity_info.status_code === 1) {
    //  axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.friendly_url}`, myHeaders_Auth_With_Cache_Control);
    //}

  }

  function handleAddUserReadWriteDropdownChange (tmp_add_user_read_write_option_index) {
    setAddUserReadWriteOptionIndex(tmp_add_user_read_write_option_index);
  }

  function handleAddUserTextChange (event) {
    //console.log("handleAddUserReadWriteDropdownChange",event.target.value);
    setAddUserText(event.target.value);
    setAddUserTextInvalid('');
    setAddUserTextValid('');
  }
  
  async function handleAddUser () {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(add_user_text)) {
      console.log("IN-VALID EMAIL");
      setAddUserTextInvalid('\''+add_user_text+'\' is not a valid email address');
      setAddUserTextValid('');
      return;
    }
    
    let workspace_base_url = '';
    if (org_friendly_url) {
      workspace_base_url = local_routes.workspace.slice(1)+"/"+org_friendly_url+"/";
    }
    
    console.log("VALID EMAIL");
    
    // get user info for given email address
    try {
      setLoading(true);
      let response_data = await axios.get(`${apiUrl}users/getByEmail/${add_user_text}`,myHeaders_Auth_With_Cache_Control);
      let user_data = response_data.data;
      
      let nickname = assembleNickname(user_data);
      /*
      let nickname = "";
      if (user_data.entity_name) {
        nickname = user_data.entity_name;
      } else if (user_data.firstname || user_data.lastname) {
        nickname = (user_data.firstname+' ' || '')+(user_data.lastname || '');
      }
      */
      if (user_data.entity_uuid === user_entity_uuid) {
        nickname += ' (you)';
      }
      
      let entity_info = {
        entity_uuid: user_data.entity_uuid,
        entity_type: 'users',
        nickname,
        read_write_option_index: add_user_read_write_option_index
      }
      
      if (entity_access_array.some(e => e.entity_type === 'users' && e.entity_uuid === user_data.entity_uuid)) {
        console.log("ALREADY EXISTS");
        setAddUserTextInvalid('\''+add_user_text+'\' already has access');
        return;
      }
      
      if (org_uuid && (!user_data.organizations_uuids || !user_data.organizations_uuids.includes(org_uuid))) {
        console.log("NOT PART OF WORKSPACE");
        setAddUserTextInvalid('\''+add_user_text+'\' is not part of your team');
        return;
        
      }
      console.log("ADDING",entity_info,add_user_read_write_option_index);

      //handleSharedAccessDropdownChange(entity_info,add_user_read_write_option_index);
      
      let read_write_option_obj = read_write_options[add_user_read_write_option_index];
  
      let patch_obj = {};
  
      let grant_clause = '';
      if (read_write_option_obj.action === 'write') {
        patch_obj = {
          [entity_info.entity_type]: [
            {
              entity_uuid: entity_info.entity_uuid,
              xref_data: {
                entity_owner_integer: 2
              }
            }
          ]
        };
        grant_clause = 'Edit privileges';
        if (props.entity_info.entity_type === 'presentations') {
          // also grant access to all the related slides
          let params = {
            filter_obj: {
              order_integer: {
                gte: 1
              }
            }
          }
          let slides_result = await axios.get(`${apiUrl}presentations/${props.entity_info.entity_uuid}/slides`, { params, ...myHeaders_Auth_With_Cache_Control });
          if (slides_result.data) {
            let slide_update_promises = [];
            slides_result.data.forEach( element => {
              let slide_patch_obj = {
                [entity_info.entity_type]: [
                  {
                    entity_uuid: entity_info.entity_uuid,
                    xref_data: {
                      entity_owner_integer: 2,
                      //entity_reader_integer: -1
                    }
                  }
                ]
              }
              slide_update_promises.push(axios.patch(`${apiUrl}slides/${element.entity_uuid}`,slide_patch_obj));
            });
            await Promise.all(slide_update_promises);
          }
        }

      } else if (read_write_option_obj.action === 'read') {
        patch_obj = {
          [entity_info.entity_type]: [
            {
              entity_uuid: entity_info.entity_uuid,
              xref_data: {
                entity_reader_integer: 2
              }
            }
          ]
        };
        grant_clause = 'View privileges';
      }

      console.log("patch_obj",patch_obj);
  
      axios.patch(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`,patch_obj);
      
      // let link_base_url = window.location.protocol + '//' + window.location.hostname + '/';
      // if (window.location.hostname === 'localhost' && window.location.port === "3000") {
      //   link_base_url = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/';
      // }
      const link_base_url = get_link_base_url();
      
      let entity_url = '$link_base_url$'+workspace_base_url+local_routes[props.entity_info.entity_type].slice(1)+'/'+props.entity_info.friendly_url;
      let more_info_url = '$link_base_url$'+workspace_base_url+local_routes.pklist.slice(1);
      let account_settings_url = '$link_base_url$'+local_routes.accountsettings.slice(1);
      let subject = props.entity_info.entity_type.charAt(0).toUpperCase()+props.entity_info.entity_type.slice(1,-1)+' '+props.entity_info.entity_name+' Has Been Shared with You';
      let information = 'PechaKucha.com '+props.entity_info.entity_type.slice(0,-1)+' '+props.entity_info.entity_name+' has been shared with you by '+user_context.user_info.nickname+' (with '+grant_clause+').<br/>You can view it <a href=\''+entity_url+'\'>here</a>';

      if (props.entity_info.entity_type === 'events') {
        more_info_url = '$link_base_url$'+workspace_base_url+local_routes.myevents.slice(1);
      } else if (props.entity_info.entity_type === 'groups' || props.entity_info.entity_type === 'locations' || props.entity_info.entity_type === 'channels') {
        more_info_url = '$link_base_url$'+workspace_base_url+local_routes[props.entity_info.entity_type].slice(1);
        subject = 'You have been added to the '+props.entity_info.entity_name+' '+props.entity_info.entity_type.charAt(0).toUpperCase()+props.entity_info.entity_type.slice(1,-1);
        information = user_context.user_info.nickname+' has added you to the PechaKucha.com '+props.entity_info.entity_type.slice(0,-1)+' '+props.entity_info.entity_name+' (with '+grant_clause+').<br/>You can view it <a href=\''+entity_url+'\'>here</a>';
      }

      let email_template_data = {
          subject,
          information,
          more_information: 'All of your '+props.entity_info.entity_type.slice(0,-1)+' information can be found <a href=\''+more_info_url+'\'>here</a>.',
          account_settings_url
      };
      
      let email_notification_post_obj = {
          email_template_data,
          user_uuid: user_data.entity_uuid,
          email_template_name: 'ses_email_triggered-presentation_event_notification',
          link_base_url
      };
      
      axios.post(`${apiUrl}users/sendTemplateEmail`, email_notification_post_obj);

      let tmp_entity_owners_array = [...entity_access_array];
      tmp_entity_owners_array.push(entity_info);
      setEntityAccessArray(tmp_entity_owners_array);

      setAddUserTextValid('\''+add_user_text+'\' added');
      setAddUserText('');
      
    } catch (err) {
      console.log("COULD NOT FIND",err);
      if (err['status'] === 404) {
        setAddUserTextInvalid('No PechaKucha.com account found with email address \''+add_user_text+'\'');
        setAddUserTextValid('');
      }
    } finally {
      setLoading(false);
    }
    
    
  }
  
  async function handlePresenterChange (entity_item,entity_index) {
    console.log("handlePresenterChange",total_presenters,entity_item,entity_index);
    if (entity_access_array[entity_index].presenter_integer >= 1 && total_presenters <= 1) {
      // need at least one presenter - don't allow remove presenter
      console.log("ERROR! Must have at least one presenter");
      // display error message to user
      setAddUserTextValid('');
      setAddUserTextInvalid('Presentation must have at least one presenter');
      return;
    }
    
    let tmp_entity_owners_array = [...entity_access_array];

    let add_presenter_flag = true;
    if (tmp_entity_owners_array[entity_index].presenter_integer) {
      // already a presenter - we are removing as a presenter
      add_presenter_flag = false;
    }
    
    //tmp_entity_owners_array[entity_index].presenter = !tmp_entity_owners_array[entity_index].presenter;
    
    // we may have to update other presenter_integers
    // make an array of presenters
    let presenters_array = tmp_entity_owners_array.filter((element) => element.presenter_integer >= 1);

    // sort presenters by presenter_integer
    presenters_array = presenters_array.sort((a, b) => (a.presenter_integer > b.presenter_integer) ? 1 : -1);

    let update_presenters_patch_obj_array = [];
    
    if (add_presenter_flag) {
      // adding a presenter - add to end of array
      presenters_array.push(entity_item);
      tmp_entity_owners_array[entity_index].disabled = true;
      //tmp_entity_owners_array[entity_index].presenter_integer = presenters_array.length;
    } else {
      // if we are removing as presenter, remove from presenters_array
      presenters_array = presenters_array.filter((element) => element.entity_uuid !== entity_item.entity_uuid);
      tmp_entity_owners_array[entity_index].presenter_integer = null;
      tmp_entity_owners_array[entity_index].disabled = false;
      update_presenters_patch_obj_array.push(
        {
          entity_uuid: entity_item.entity_uuid,
          xref_data: {
            presenter_integer: -1
          }
        }
      );
    }

    // now build array of patch objects
    presenters_array.forEach((item,i) => {
      update_presenters_patch_obj_array.push(
        {
          entity_uuid: item.entity_uuid,
          xref_data: {
            presenter_integer: i+1
          }
        }
      );
      // update presenter_integer for display purposes
      tmp_entity_owners_array.forEach((item2) => {
        if (item2.entity_uuid === item.entity_uuid) {
          item2.presenter_integer = i+1;
        }
      })
    });
    
    let update_presenter_patch_obj = {
      [entity_item.entity_type]: update_presenters_patch_obj_array
    };
    
    /*
    if (!tmp_entity_owners_array[entity_index].presenter_integer) {
      // make presenter
      update_presenter_patch_obj = {
        [entity_item.entity_type]: [
          {
            entity_uuid: entity_item.entity_uuid,
            xref_data: {
              presenter_integer: total_presenters+1
            }
          }
        ]
      };
      tmp_entity_owners_array[entity_index].presenter_integer = total_presenters+1;
      setTotalPresenters(total_presenters+1);
    } else {
      // remove presenter
      update_presenter_patch_obj = {
        [entity_item.entity_type]: [
          {
            entity_uuid: entity_item.entity_uuid,
            xref_data: {
              presenter_integer: -1
            }
          }
        ]
      };
      tmp_entity_owners_array[entity_index].presenter_integer = null;
      setTotalPresenters(total_presenters-1);
    }
    */
    setTotalPresenters(presenters_array.length);
    setEntityAccessArray(tmp_entity_owners_array);
      
    console.log("update_presenter_patch_obj",update_presenter_patch_obj);
  
    await axios.patch(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`,update_presenter_patch_obj);
    
    setAddUserTextInvalid('');
    if (add_presenter_flag) {
      setAddUserTextValid('Presenter Added');
    } else {
      setAddUserTextValid('Presenter Removed');
    }
    
  }

  // on modal mount
  useEffect(() => {
    // setup entity owners array
    //if (org_friendly_url) {
    //  setWorkspaceBaseUrl(local_routes.workspace.slice(1)+"/"+org_friendly_url+"/");
    //}
    if (!props.show || entity_access_array.length > 0) {
      // we are hiding, or we already have our list
      setAddUserTextValid('');
      setAddUserTextInvalid('');
      return;
    }
    
    const fetchData = async () => {
      console.log("ShareAccessModal fetching owners");
      
      let tmp_total_presenters = total_presenters;
      
      let tmp_entity_owners_array = [];

      let users_api_promises = [];
      let users_api_promises_types = [];

      users_api_promises.push(axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}/users?filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1}}')}`,myHeaders_Auth_With_Cache_Control));
      users_api_promises_types.push({entity_type:'users',access_type:'write'});

      users_api_promises.push(axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}/users?filter_obj=${encodeURIComponent('{"entity_reader_integer":{"gte":1}}')}`,myHeaders_Auth_With_Cache_Control));
      users_api_promises_types.push({entity_type:'users',access_type:'read'});

      // special case for presentations with legacy presenters who are not owners
      if (props.entity_info.entity_type === 'presentations') {
        let presentation_presenter_users_params = {
          filter_obj: {
            presenter_integer: {
              gte: 1
            },
            entity_owner_integer: {
              exists: false
            }
          }
        };
        users_api_promises.push(axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}/users`,{ params: presentation_presenter_users_params, ...myHeaders_Auth_With_Cache_Control }));
        users_api_promises_types.push({entity_type:'users',access_type:'presenter_only'});
      }
      
      let api_response_array = await Promise.all(users_api_promises);

      for (let api_response of api_response_array) {
        
        let access_obj = users_api_promises_types.shift();
        
        for (let user_obj of api_response.data) {
          if (!user_obj.xref_data) {
            console.error("BAD USER",user_obj);
            continue;
          }
          
          let nickname = assembleNickname(user_obj);
          let disabled = false;
          let presenter_integer = null;
          let read_write_option_index = 1;
          
          if (user_obj.entity_uuid === user_entity_uuid) {
            nickname += ' (you)';
            disabled = true;
          }
          
          if (access_obj.access_type === 'write') {
            read_write_option_index = 0;
            if (user_obj.xref_data.entity_owner_integer === 1) {
              nickname += ' (creator)';
              disabled = true;
            }
            if (user_obj.xref_data.presenter_integer >= 1) {
              presenter_integer = user_obj.xref_data.presenter_integer;
              disabled = true;
              tmp_total_presenters++;
            }
          } else if (access_obj.access_type === 'read') {
            read_write_option_index = 1;
            if (user_obj.xref_data.presenter_integer >= 1) {
              presenter_integer = user_obj.xref_data.presenter_integer;
              disabled = true;
              tmp_total_presenters++;
            }
          } else if (access_obj.access_type === 'presenter_only') {
            // presenter-only - this is for legacy presentations where the presenter might not be an owner
            read_write_option_index = 3; 
            presenter_integer = user_obj.xref_data.presenter_integer;
            tmp_total_presenters++;
          }
          console.log('\n\nUSER OBJECT:', user_obj)
          let owner_obj = {
            entity_type: access_obj.entity_type,
            entity_uuid: user_obj.entity_uuid,
            img_url: user_obj.avatar_image_url ? get_modified_image_url(user_obj.avatar_image_url, 'circle_50x50') : null,
            nickname,
            //read_write_option_index: access_obj.access_type === 'write' ? 0 : 1,
            read_write_option_index,
            disabled,
            presenter_integer
          };
          tmp_entity_owners_array.push(owner_obj);      
        }
      }

      if (org_uuid) {
        // in workspace...add information-only "Team Admin" owner
        let owner_obj = {
          entity_type: '',
          entity_uuid: '',
          nickname: 'Team Admins',
          read_write_option_index: 0, // write
          disabled: true,
          presenter: false
        };
        tmp_entity_owners_array.push(owner_obj);
      }

      setTotalPresenters(tmp_total_presenters);
      setEntityAccessArray(tmp_entity_owners_array);
    };
 
    fetchData();
  }, [props.show]);


  return (
    <Modal
      style={{ color: 'black' }}
      show={props.show}
      onHide={props.onHide}
      //{...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.entity_info.entity_name}<br/>
          <span style={{ fontSize: "smaller", color: "darkgray" }}>Privacy and Sharing Settings</span>
          { (props.publish_dropdown_options.length === 1 && props.entity_info.entity_type === 'presentations' && user_access_level !== 'admin' && !owner_perms.organizations) &&
            <React.Fragment>
              <br/>
              <div style={{ paddingLeft: "20px", fontSize: "small" }}>
                <a style={{ color: "#16a085" }} target="_blank" href={local_routes.pricing}>Want to make your Presentation private? Click here to find out more about PK Create PRO</a>
              </div>
            </React.Fragment>
          }
          { (props.publish_dropdown_options.length === 1 && props.entity_info.entity_type === 'presentations' && (user_access_level === 'admin' || owner_perms.organizations)) &&
            <React.Fragment>
              <br/>
              <div style={{ paddingLeft: "20px", fontSize: "small" }}>
                <span style={{ color: "#16a085" }}>Want to make your Presentation private? Switch to your Team View to see your Team Presentations</span>
              </div>
            </React.Fragment>
          }
          
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ReactTooltip />
        <Container>
          <Row>
            <Col>
              Update Privacy
            </Col>
            <Col xs='auto'>
                  { props.publish_dropdown_options.length === 1 &&
                      <span data-tip={props.publish_dropdown_options[publish_dropdown_option_index].tooltip}>
                          {props.publish_dropdown_options[publish_dropdown_option_index].title}
                      </span>
                  }
                  { props.publish_dropdown_options.length > 1 &&
                          <DropdownButton
                              //data-tip={props.publish_dropdown_options[publish_dropdown_option_index].tooltip}
                              variant="pk"
                              alignRight
  
                              title={<span>{props.publish_dropdown_options[publish_dropdown_option_index].title} {props.publish_dropdown_options[publish_dropdown_option_index].icon}</span>}
  
                              //drop={'left'}
                          >
                          {
                              props.publish_dropdown_options.map((item,index) => {
                                  if (index === publish_dropdown_option_index) {
                                      return <React.Fragment key={index}></React.Fragment>;
                                  }
                                  return (
                                      <Dropdown.Item
                                          key={index}
                                          onClick={() => handlePublishDropdownChange(index)}
                                      >
                                          {item.title} {item.icon}
                                      </Dropdown.Item>
                                  );
                              })
                          }
                            
                          </DropdownButton>
                  }
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col xs={5}>  
              <span style={{ fontWeight: "bolder" }}>Who has access</span>
            </Col>
            { props.entity_info.entity_type === 'presentations' &&
              <Col xs={3}>  
                <span style={{ fontWeight: "bolder" }}>Presenter?</span>
              </Col>
            }
            <Col xs='auto'>
            </Col>
          </Row>
          { 
            entity_access_array.map((entity_item, entity_index) =>
              <Row style={{ paddingBottom: "5px" }} key={entity_index}>
                <Col xs={5} style={{}}>
                  <div style={{display: 'flex', alignItems: 'center'}} className="mt-1">
                    <img style={{width: '100%', maxWidth: '35px', borderRadius: '50%', marginRight: '.5rem'}} alt="" src={entity_item.img_url} /> 
                    <div>{entity_item.nickname}</div>
                  </div>
                </Col>
                { (props.entity_info.entity_type === 'presentations' && (entity_item.read_write_option_index === 0 || entity_item.presenter_integer)) ?
                  <Col xs={3}>
                    {/*Presenter? {entity_item.presenter ? 'YES' : 'NO'}*/}
                    <Form.Check className="presenter-checkbox">
                      <FormCheck.Input
                        checked={entity_item.presenter_integer >= 1 ? true : false}
                        onChange={() => handlePresenterChange(entity_item,entity_index)}
                      />
                      <FormCheck.Label className="presenter-checkbox-label">
                        {entity_item.presenter_integer >= 1 ? ' #'+entity_item.presenter_integer : ''}
                      </FormCheck.Label>
                    </Form.Check>
                  </Col>
                  :
                  <Col xs={3}>
                  </Col>
                }
                <Col xs='auto'>
                {/* <Col xs={4}> */}
                  <DropdownButton
                      //data-tip={read_write_options[itpublish_dropdown_option_index].tooltip}
                      //disabled={entity_item.entity_uuid === user_entity_uuid}
                      disabled={entity_item.disabled}
                      variant="pk"
                      alignRight
                      title={<span>{read_write_options[entity_item.read_write_option_index].title} {read_write_options[entity_item.read_write_option_index].icon}</span>}

                      //drop={'left'}
                  >
                  {
                      read_write_options.map((item,index) => {
                          if (index === entity_item.read_write_option_index) {
                            // if current option
                            return <React.Fragment key={index}></React.Fragment>;
                          }
                          if (item.action === 'read' && props.publish_dropdown_options[publish_dropdown_option_index].public_status !== 'super_private') {
                            // if not super_private, can't add viewers
                            return <React.Fragment key={index}></React.Fragment>;
                          }
                          if (item.action === 'presenter_only') {
                            return <React.Fragment key={index}></React.Fragment>;
                          }
                          if (item.action === 'remove' && entity_item.read_write_option_index === 3) {
                            // if presenter-only (legacy), you can't remove
                            return <React.Fragment key={index}></React.Fragment>;
                          }
                          return (
                              <Dropdown.Item
                                  key={index}
                                  onClick={() => handleSharedAccessDropdownChange(entity_item,entity_index,index)}
                              >
                                  {item.title} {item.icon}
                              </Dropdown.Item>
                          );
                      })
                  }
                  </DropdownButton>
                </Col>
              </Row>
            )
          }
          <hr/>
					{(entity_access_array.length>=10)?(null):(
						<Row style={{ marginBottom: "20px" }}>
            <Col>
              <span
                data-tip={"Enter email address and press 'Enter' to add"}
              >
                Add people:
              </span>
              <InputGroup>
                <FormControl
                  disabled={loading}
                  placeholder={loading ? 'Working...' : "Email address"}
                  value={add_user_text}
                  onChange={handleAddUserTextChange}
                  aria-label="Email address"
                  aria-describedby="basic-addon2"
                  onKeyPress={event => {
                    if (event.key === "Enter") {
                      handleAddUser();
                    }
                  }}
                />
                <Button
                  variant="pkprimary"
                  onClick={() => handleAddUser()}
                >
                  Add
                </Button>
                <DropdownButton
                    //data-tip={read_write_options[itpublish_dropdown_option_index].tooltip}
                    //disabled={entity_item.entity_uuid === user_entity_uuid}
                    disabled={props.publish_dropdown_options[publish_dropdown_option_index].public_status !== 'super_private'}
                    variant="pk"
                    alignRight
                    title={<span>{read_write_options[add_user_read_write_option_index].title} {read_write_options[add_user_read_write_option_index].icon}</span>}

                    //drop={'left'}
                >
                {
                    read_write_options.map((item,index) => {
                        if (index === add_user_read_write_option_index || index === (read_write_options.length-1)) {
                           // if current option or remove, don't show
                          return <React.Fragment key={index}></React.Fragment>;
                        }
                        if (item.action === 'read' && props.publish_dropdown_options[publish_dropdown_option_index].public_status !== 'super_private') {
                          // if not super_private, can't add viewers
                          return <React.Fragment key={index}></React.Fragment>;
                        }
                        return (
                            <Dropdown.Item
                                key={index}
                                onClick={() => handleAddUserReadWriteDropdownChange(index)}
                            >
                                {item.title} {item.icon}
                            </Dropdown.Item>
                        );
                    })
                }
                </DropdownButton>
              </InputGroup>
              { !loading && add_user_text_invalid &&
                <span style={{ color: 'red', fontSize: 'smaller' }}> {add_user_text_invalid}</span>
              }
              { !loading && add_user_text_valid &&
                <span style={{ color: 'green', fontSize: 'smaller' }}> {add_user_text_valid}</span>
              }
              { loading &&
                <span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>
              }
            </Col>
          </Row>
					)}
          
        </Container>
      </Modal.Body>
      {/*
      <Modal.Footer>
        <Button className="modal_button_white" onClick={props.onHide}>Done</Button>
      </Modal.Footer>
      */}
    </Modal>
  );
}

function ShareAccessModalButton (props) {
  console.log('ShareAccessModalButton PROPS:', props)
  const [modalShow, setModalShow] = React.useState(false);
  
  const [publish_dropdown_options, setPublishDropdownOptions] = useState([]);
  const [publish_dropdown_option_index, setPublishDropdownOptionIndex] = useState(0);
  
  //console.log("ShareAccessModalButton",props);

  //let button_icon = props.publish_dropdown_options[props.publish_dropdown_option_index].icon;
  //let button_text = '';
  //let button_tooltip = props.publish_dropdown_options[props.publish_dropdown_option_index].tooltip;
  
  //let workspace_base_url = '';
  
  let all_publish_dropdown_options = {
    events: {
      workspace_admin: [
          {
              title: 'Team View',
              //status_code: 1,
              public_status: 'private',
              icon: <i className="fa fa-user-circle"/>,
              tooltip: 'Privacy and Sharing Settings: Event page available to anybody in your Team'
          },
          {
              title: 'Private',
              //status_code: 1,
              public_status: 'super_private',
              icon: <i className="fa fa-lock"/>,
              tooltip: 'Privacy and Sharing Settings: Event page only available to you, Team Admins, and selected users'
          },
          {
              title: 'Public',
              //status_code: 1,
              public_status: 'public',
              icon: <i className="fa fa-users"/>,
              tooltip: 'Privacy and Sharing Settings: Event page available to anybody on PechaKucha.com'
          }
      ],
      workspace_normal: [
          {
              title: 'Team View',
              //status_code: 1,
              public_status: 'private',
              icon: <i className="fa fa-user-circle"/>,
              tooltip: 'Privacy and Sharing Settings: Event page available to anybody in your Team'
          },
          {
              title: 'Private',
              //status_code: 1,
              public_status: 'super_private',
              icon: <i className="fa fa-lock"/>,
              tooltip: 'Privacy and Sharing Settings: Event page only available to you, Team Admins, and selected Team Users'
          }
      ],
      normal: [
          {
              title: 'Public',
              //status_code: 1,
              public_status: 'public',
              icon: <i className="fa fa-users"/>,
              tooltip: 'Privacy and Sharing Settings'
          }
      ]
    },
    presentations: {
      workspace_admin: [
          {
              title: 'Team View',
              //status_code: 1,
              public_status: 'private',
              icon: <i className="fa fa-user-circle"/>,
              tooltip: 'Privacy and Sharing Settings: Presentation page available to anybody in your Team'
          },
          {
              title: 'Private',
              //status_code: 1,
              public_status: 'super_private',
              icon: <i className="fa fa-lock"/>,
              tooltip: 'Privacy and Sharing Settings: Presentation page only available to you, Team Admins, and selected Team Users'
          },
          {
              title: 'Public',
              //status_code: 1,
              public_status: 'public',
              icon: <i className="fa fa-users"/>,
              tooltip: 'Privacy and Sharing Settings: Presentation page available to anybody on PechaKucha.com'
          }
      ],
      workspace_normal: [
          {
              title: 'Team View',
              //status_code: 1,
              public_status: 'private',
              icon: <i className="fa fa-user-circle"/>,
              tooltip: 'Privacy and Sharing Settings: Presentation page available to anybody in your Team'
          },
          {
              title: 'Private',
              //status_code: 1,
              public_status: 'super_private',
              icon: <i className="fa fa-lock"/>,
              tooltip: 'Privacy and Sharing Settings: Presentation page only available to you, Team Admins, and selected Team Users'
          },
          {
              title: 'Public',
              //status_code: 1,
              public_status: 'public',
              icon: <i className="fa fa-users"/>,
              tooltip: 'Privacy and Sharing Settings: Presentation page available to anybody on PechaKucha.com'
          }
      ],
      pro: [
          {
              title: 'Public',
              //status_code: 1,
              public_status: 'public',
              icon: <i className="fa fa-users"/>,
              tooltip: 'Privacy and Sharing Settings: Presentation page available to anybody on PechaKucha.com'
          },
          {
              title: 'Private',
              //status_code: 1,
              public_status: 'super_private',
              icon: <i className="fa fa-lock"/>,
              tooltip: 'Privacy and Sharing Settings: Presentation page only available to you and selected users'
          },
      ],
      normal: [
          {
              title: 'Public',
              //status_code: 1,
              public_status: 'public',
              icon: <i className="fa fa-users"/>,
              tooltip: 'Privacy and Sharing Settings'
          }
      ]
    },
		locations:{
			normal: [
				{
						title: 'Public',
						//status_code: 1,
						public_status: 'public',
						icon: <i className="fa fa-users"/>,
						tooltip: 'Privacy and Sharing Settings'
				}
		]
		},
    channels: {
      normal: [
        {
            title: 'Public',
            //status_code: 1,
            public_status: 'public',
            icon: <i className="fa fa-users"/>,
            tooltip: 'Privacy and Sharing Settings'
        }
    ]
    }
  };

  // on button mount
  useEffect(() => {
    let workspace_base_url = '';
    if (org_friendly_url) {
      workspace_base_url = local_routes.workspace.slice(1)+"/"+org_friendly_url+"/";
    }
    if (workspace_base_url) {
        if (organization_user_access_level === 'admin' || user_access_level === 'admin') {
            setPublishDropdownOptions(all_publish_dropdown_options[props.entity_info.entity_type]['workspace_admin']);
            let tmp_publish_dropdown_option_index = all_publish_dropdown_options[props.entity_info.entity_type]['workspace_admin'].findIndex(item => {
                if (item.public_status === props.entity_info.public_status) {
                    return true;
                }
            });
            if (tmp_publish_dropdown_option_index >= 0) {
                setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
            }
        } else {
            setPublishDropdownOptions(all_publish_dropdown_options[props.entity_info.entity_type]['workspace_normal']);
            let tmp_publish_dropdown_option_index = all_publish_dropdown_options[props.entity_info.entity_type]['workspace_normal'].findIndex(item => {
                if (item.public_status === props.entity_info.public_status) {
                    return true;
                }
            });
            if (tmp_publish_dropdown_option_index >= 0) {
                setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
            }
        }
    } else if (props.entity_info.entity_type === 'presentations' && (user_account_level === 'private' || user_access_level === 'admin')) {
        setPublishDropdownOptions(all_publish_dropdown_options[props.entity_info.entity_type]['pro']);
        let tmp_publish_dropdown_option_index = all_publish_dropdown_options[props.entity_info.entity_type]['pro'].findIndex(item => {
            if (item.public_status === props.entity_info.public_status) {
                return true;
            }
        });
        if (tmp_publish_dropdown_option_index >= 0) {
            setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
        }
    // } else if (props.entity_info.entity_type === 'locations' && (user_account_level === 'private' || user_access_level === 'admin')){
    } else if (props.entity_info.entity_type === 'locations'){
        // normal public view
        console.log('CITIES')
        setPublishDropdownOptions(all_publish_dropdown_options[props.entity_info.entity_type]['normal']);
        let tmp_publish_dropdown_option_index = all_publish_dropdown_options[props.entity_info.entity_type]['normal'].findIndex((item,index) => {
            if (item.public_status === props.entity_info.public_status) {
              console.log('FOUND:', item.public_status, props.entity_info.public_status)
                return index;
            }
        });
        if (tmp_publish_dropdown_option_index >= 0) {
            setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
        }
    } else {
      // Should run for ChannelInfo component
      console.log('CHANNELS')
      setPublishDropdownOptions(all_publish_dropdown_options[props.entity_info.entity_type]['normal']);
        let tmp_publish_dropdown_option_index = all_publish_dropdown_options[props.entity_info.entity_type]['normal'].findIndex((item,index) => {
            if (item.public_status === props.entity_info.public_status) {
                return index;
            }
        });
        if (tmp_publish_dropdown_option_index >= 0) {
            setPublishDropdownOptionIndex(tmp_publish_dropdown_option_index);
        }
    }
    
  }, [props.entity_info]);

  if (!props.entity_info.entity_uuid || !publish_dropdown_options[publish_dropdown_option_index]) {
    return (<React.Fragment></React.Fragment>);
  }

  return (
    <React.Fragment>
      <Button
        //style={{ width: "50px" }}
        size="sm"
        data-tip={publish_dropdown_options[publish_dropdown_option_index].tooltip}
        variant="pkprimary"
        onClick={() => setModalShow(true)}
      >
        {publish_dropdown_options[publish_dropdown_option_index].icon}
      </Button>

      <ShareAccessModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        entity_info={props.entity_info}
        publish_dropdown_options={publish_dropdown_options}
        publish_dropdown_option_index={publish_dropdown_option_index}
        OnChangePublishOption={props.OnChangePublishOption || null} // optional
        index={props.index || null} // optional
      />
      <ReactTooltip />
    </React.Fragment>
  );
}

export default ShareAccessModalButton;